import {BaseView} from "../core/view"
import constants from "./constants"
import { LinkUtil } from "../utils/link"
import { TrackingUtil } from "../utils/tracking"

export default BaseView.extend({

    el: '.js-price-filter',
    minLabelElement: undefined,
    maxLabelElement: undefined,
    minValue: undefined,
    maxValue: undefined,
    initialMinValue: undefined,
    initialMaxValue: undefined,
    url: undefined,
    goToUrl: undefined,

    events: {
        'slide': 'updateLabels',
        'slideStop': 'validateFilterPrices',
        'click' : 'stopPropagation',
        'click .js-price-button-reset' : 'resetFilter',
        'click .js-price-button-apply' : 'applyFilter',
        'change .js-price-input-min': 'validateFilterPrices',
        'change .js-price-input-max': 'validateFilterPrices'
    },
    
    templates: {
        PRICE_FILTER_TEMPLATE: require("./templates/price-filter.hbs"),
    },
    
    throwPriceFilterEvent: _.once(function(e){
    	TrackingUtil.throwGAEvent(constants.TRACK_FILTER_USAGE, 'FilterPrice', '', false);
    }),
    
    stopPropagation: function(e) {
        e.stopPropagation();
    },

    updateLabels: function(e) {
        this.minLabelElement.val(e.value[0]);
        this.maxLabelElement.val(e.value[1]);
    },
    
    resetFilter: function(e){
        if (!this.$el.find(e.currentTarget).hasClass("button--inactive")){
            LinkUtil.goToUrl(this.url);
        }
    },
    
    applyFilter: function(e) {
        if (!this.$el.find(e.currentTarget).hasClass("button--inactive")){
        	this.throwPriceFilterEvent();
            var parameters = {},
             searchUrl = this.url,
             minInput = parseInt(this.minLabelElement.val()),
             maxInput = parseInt(this.maxLabelElement.val());

            if (minInput !== this.initialMinValue || maxInput !== this.initialMaxValue) {

                if (minInput !== this.minValue) {
                    parameters.minPrice = minInput;
                    TrackingUtil.throwFilterClickedEvent('minPrice', minInput);
                }
                if (maxInput !== this.maxValue) {
                    parameters.maxPrice = maxInput;
                    TrackingUtil.throwFilterClickedEvent('maxPrice', maxInput);
                }

                var parametersString = this.joinParameters(parameters);
                
                if (parametersString.length) {
                    if (searchUrl.indexOf('?') === -1) {
                        searchUrl += '?';
                    } else {
                        searchUrl += '&';
                    }
                }
                this.goToUrl = searchUrl + parametersString;
                    
            }
            LinkUtil.goToUrl(this.goToUrl);
        }
    },
    
    activateApply: function(){
        
        
        var minInput = parseInt(this.minLabelElement.val()),
        maxInput = parseInt(this.maxLabelElement.val());
        
        if ((minInput != this.initialMinValue)||(maxInput!=this.initialMaxValue)) {
            $('.js-price-button-apply').removeClass("button--inactive");
        }else{
            $('.js-price-button-apply').addClass("button--inactive");
        }
    },
    
    validateFilterPrices: function() {
        var minInput = parseInt(this.minLabelElement.val()),
        maxInput = parseInt(this.maxLabelElement.val());
        
        if (minInput < this.minValue){
            minInput = this.minValue;
        }
        if (minInput >= this.maxValue){
            minInput = this.maxValue - 1;
        }
        if (maxInput <= this.minValue){
            maxInput = this.minValue + 1;
        }
        if (maxInput > this.maxValue){
            maxInput = this.maxValue;
        }
        if (maxInput <= minInput){
            maxInput = minInput+1;
        }
        if (minInput >= maxInput){
            minInput = maxInput-1;
        }
        this.minLabelElement.val(minInput);
        this.maxLabelElement.val(maxInput);
        this.$el.find('[data-bind=priceslider]').slider('setValue', [minInput, maxInput]);
        this.activateApply();
    },

    joinParameters: function(parameters) {
        var ret = [];
        for (var p in parameters) {
            ret.push(p + "=" + parameters[p]);
        }
        return ret.join('&');
    },

    initialize: function(priceData, freeShippingData, saleData) {

    	var data = {
    		prefixCurrency: priceData.currencyIsPrefixed,
        	minLabelValue: priceData.min,
        	maxLabelValue: priceData.max,
        	currency: priceData.currency,
        	absoluteMin: priceData.filterMin,
        	absoluteMax: priceData.filterMax,
            priceFilterSetted: (priceData.min > priceData.filterMin) || (priceData.max < priceData.filterMax),
        	deletePriceFilterUrl: priceData.url,
            applyText: getI18N(jlocale.apply),
            resetText: getI18N(jlocale.reset)
        }
    	
    	this.$el.find('.detail').html(this.templates.PRICE_FILTER_TEMPLATE(data));
    	this.$el.find('[data-bind=priceslider]').slider();

        this.minLabelElement = this.$el.find('.js-price-input-min');
        this.maxLabelElement = this.$el.find('.js-price-input-max');
        this.initialMinValue = data.minLabelValue;
        this.initialMaxValue = data.maxLabelValue;
        this.minValue = data.absoluteMin;
        this.maxValue = data.absoluteMax;
        this.url = data.deletePriceFilterUrl;
    }
});
